import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/items',
    name: 'Item',
    component: {
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'item',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminItemIndex',
        component: () => import('../views/ItemIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminItemNew',
        component: () => import('../views/ItemInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminItemIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminItemShow',
        component: () => import('../views/ItemShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminItemIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminItemDetails',
            component: () => import('../views/ItemDetails.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminItemEdit',
            component: () => import('../views/ItemInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminItemShow' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminItemAttachments',
            component: () => import('../views/attachment/ItemAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminItemAttachmentsEdit',
            component: () => import('../views/attachment/ItemAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminItemAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'purchase_prices',
            name: 'AdminItemPurchasePrices',
            component: () => import('../views/purchasePrice/ItemPurchasePrices.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'purchase_price',
            },
          },
          {
            path: 'price_list_entries',
            name: 'AdminItemPriceListEntries',
            component: () => import('../views/priceListEntry/ItemPriceListEntries.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              customName: 'views.item.price_list_entry',
            },
          },
          {
            path: 'cost_prices',
            name: 'ItemCostPrices',
            component: {
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'cost_price',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminItemCostPrices',
                component: () => import('../views/costPrice/CostPriceIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminItemIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminItemCostPriceNew',
                component: () => import('../views/costPrice/CostPriceInput.vue'),
                meta: {
                  action: 'new',
                  resource: 'cost_price',
                  backRoute: { name: 'AdminItemCostPrices' },
                },
              },
              {
                path: ':costPriceId(\\d+)',
                name: 'AdminItemCostPriceShow',
                component: () => import('../views/costPrice/CostPriceShow.vue'),
                meta: {
                  resource: 'cost_price',
                  backRoute: { name: 'AdminItemCostPrices' },
                  tArgs: route => ({ name: route?.params?.id }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminItemCostPriceDetails',
                    component: () => import('../views/costPrice/CostPriceDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminItemCostPrices' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminItemCostPriceEdit',
                    component: () => import('../views/costPrice/CostPriceInput.vue'),
                    meta: {
                      action: 'edit',
                      resource: 'cost_price',
                      backRoute: { name: 'AdminItemCostPrices' },
                    },
                  },
                ],
              },
            ]
          },
          {
            path: 'invoices',
            name: 'AdminItemInvoices',
            component: () => import('../views/invoice/ItemInvoices.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'invoice',
            },
          },
          {
            path: 'item_conversions',
            name: 'ItemItemConversion',
            component: {
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'item_conversion',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminItemItemConversions',
                component: () => import('../views/itemConversion/ItemItemConversions.vue'),
                meta: {
                  backRoute: { name: 'AdminItemIndex' },
                },
              },
              {
                path: 'conversions_from/new',
                name: 'AdminItemConversionFromNew',
                component: () => import('../views/itemConversion/ItemConversionInput.vue'),
                meta: {
                  action: 'new',
                  resource: 'item_conversion_from',
                  backRoute: { name: 'AdminItemItemConversions' },
                },
              },
              {
                path: 'conversions/:itemConversionId(\\d+)',
                name: 'AdminItemConversionEdit',
                component: () => import('../views/itemConversion/ItemConversionInput.vue'),
                meta: {
                  action: 'edit',
                  resource: 'item_conversion',
                  backRoute: { name: 'AdminItemItemConversions' },
                  tArgs: route => ({ name: route?.params?.id }),
                },
              },
              {
                path: 'conversions_to/new',
                name: 'AdminItemConversionToNew',
                component: () => import('../views/itemConversion/ItemConversionInput.vue'),
                meta: {
                  action: 'new',
                  resource: 'item_conversion_to',
                  backRoute: { name: 'AdminItemItemConversions' },
                },
              },
            ]
          },
          {
            path: 'item_units',
            name: 'ItemItemUnits',
            component: {
              render(h) {
                return h('router-view');
              },
            },
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'item_unit',
            },
            get redirect() {
              return this.children[0];
            },
            children: [
              {
                path: '',
                name: 'AdminItemItemUnits',
                component: () => import('../views/itemUnit/ItemUnits.vue'),
                meta: {
                  backRoute: { name: 'AdminItemIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminItemItemUnitNew',
                component: () => import('../views/itemUnit/ItemUnitInput.vue'),
                meta: {
                  action: 'new',
                  resource: 'item_unit',
                  backRoute: { name: 'AdminItemItemUnits' },
                },
              },
              {
                path: ':itemUnitId(\\d+)',
                name: 'AdminItemItemUnitShow',
                component: () => import('../views/itemUnit/ItemUnitShow.vue'),
                meta: {
                  resource: 'item_unit',
                  backRoute: { name: 'AdminItemItemUnits' },
                  tArgs: route => ({ name: route?.params?.id }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminItemItemUnitDetails',
                    component: () => import('../views/itemUnit/ItemUnitDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminItemItemUnits' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminItemItemUnitEdit',
                    component: () => import('../views/itemUnit/ItemUnitInput.vue'),
                    meta: {
                      action: 'edit',
                      resource: 'item_unit',
                      backRoute: { name: 'AdminItemItemUnits' },
                    },
                  },
                ],
              },
            ]
          },
          {
            path: 'stocks',
            name: 'AdminItemStocks',
            component: () => import('../views/stock/ItemStocks.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'stock',
            },
          },
          {
            path: 'logs',
            name: 'AdminItemLogs',
            component: () => import('../views/ItemLogs.vue'),
            meta: {
              backRoute: { name: 'AdminItemIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'admin/price_list_entries/new',
    name: 'AdminPriceListEntryNewWithNoPriceList',
    component: () => import('@/modules/priceList/views/priceListEntry/PriceListEntryInput.vue'),
    meta: {
      resource: 'price_list_entry',
      action: 'new',
      backRoute: { name: 'AdminPriceListPriceListEntries' },
    },
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));